<div>
  <textarea [rows]="row" [cols]="col" pInputTextarea [(ngModel)]="value" (ngModelChange)="onChange($event)"
    [autoResize]="true" class="p-inputtext-sm" [attr.maxlength]="maxlength" (focus)="focus($event)" (blur)="blur($event)"
    [style]="style" ></textarea>
  <span *ngIf="changeText && value?.length" style="float:right;"> {{value.length}}/{{maxlength}} </span>
</div>
